import { useState } from "react";
import { scheduleDays, scheduleData } from "@/mocks/anime";

export default function Schedule() {
  const [activeDay, setActiveDay] = useState("monday");
  const items = scheduleData.filter((item) => item.day === activeDay);

  return (
    <section id="schedule" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-4 md:mb-12 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-calendar-line"></i>
              新番时间表
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
              本周新番播放安排
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              按星期切换，快速定位每一天的动画播出时间，追番不再错过每一集。
            </p>
          </div>
        </div>

        <div className="mb-8 flex flex-wrap items-center gap-2">
          {scheduleDays.map((day) => {
            const active = day.key === activeDay;
            return (
              <button
                key={day.key}
                type="button"
                onClick={() => setActiveDay(day.key)}
                className={`rounded-full px-5 py-2 text-sm font-medium whitespace-nowrap transition-all ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
                }`}
              >
                {day.label}
                {active && <span className="ml-2 text-background-50/80">{items.length}</span>}
              </button>
            );
          })}
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-300"
            >
              <div className="relative h-60 w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title}新番推荐`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-time-line"></i>
                  {item.airTime}
                </span>
                <span className="absolute right-3 top-3 rounded-full bg-black/55 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
                  {item.episode}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg text-foreground-950">{item.title}</h3>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {item.genre.map((g) => (
                    <span
                      key={g}
                      className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900"
                    >
                      {g}
                    </span>
                  ))}
                </div>
                <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {item.desc}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3">
                  <span className="text-xs text-foreground-500">{item.studio}</span>
                  <a
                    href="#updates"
                    className="inline-flex items-center gap-1 text-xs font-semibold text-primary-700 hover:text-primary-600"
                  >
                    前往追番 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}